/**
 * Account mail for one person (owner, 2026-09-21): a 7-day welcome link or the 60-minute reset link,
 * confirmed first because it goes outside the company. The employee page's menu and Ansatte's
 * «Send invitasjon» (the welcome overview, #130) send it the same way.
 */
import { ApiError } from '@/api/client';
import { useUserWrites } from '@/api/people';
import { T } from '@/i18n';
import { toast } from '@/ui';

export function useAccountMail() {
  const w = useUserWrites();
  return async (u: { id: number; email?: string | null }, kind: 'welcome' | 'reset-link') => {
    const what =
      kind === 'welcome'
        ? T('en velkomst-e-post (lenken gjelder i 7 dager)')
        : T('en lenke for nytt passord (gjelder i 60 minutter)');
    if (!window.confirm(T('Sende {what} til {e}?', { what, e: u.email ?? '' }))) return;
    try {
      await w.mail.mutateAsync({ id: u.id, kind });
      toast(T('Sendt til {e}', { e: u.email ?? '' }));
    } catch (e) {
      const err = e instanceof ApiError ? e : null;
      toast(
        err?.status === 503
          ? T('E-post er ikke satt opp her, så ingenting ble sendt.')
          : err?.status === 429
            ? T('Sendt for mange ganger. Prøv igjen om en time.')
            : `${T('Ikke sendt')}: ${(e as Error).message}`,
      );
    }
  };
}
